import { data } from '../../svg/Category/data';
import { makeIcon } from '../makeIcon';

export const Category = makeIcon(data, 'category', 'Category');

export default Category;
